export default __webpack_public_path__ + "languages/zh.c9d649a3.pathmapping.json";